import { connect } from 'react-redux';
import MediaCenter from 'components/media-center/index';
import { getMediaCenter } from 'redux-modules/media-center';
import { setModalContent } from 'redux-modules/modal';
const mapStateToProps = ({ mediaCenter }) => ({
  list: mediaCenter.list,
  loading: mediaCenter.loading,
  error: mediaCenter.error
});

const mapDispatchToProps = dispatch => ({
  setModalContent: () => dispatch(setModalContent()),
  getMediaCenter: () => dispatch(getMediaCenter())
});

export default connect(mapStateToProps, mapDispatchToProps)(MediaCenter);



// WEBPACK FOOTER //
// ./app/containers/media-center/index.js